import { Link, useLoaderData } from 'react-router';
import { api } from '@/lib/api';
import { fmtAgo } from '@/lib/format';
import { SegmentForm } from './segment-form';
import { EvaluateButton } from './segment-actions';
import { RowLink } from '@/components/row-link';

type Segment = {
  id: string;
  name: string;
  description: string | null;
  kind: string;
  memberCount: number;
  lastEvaluatedAt: string | null;
  rules: unknown;
  system: boolean;
};

export async function segmentsLoader() {
  return api<Segment[]>('/segments');
}

export function SegmentsPage() {
  const segments = useLoaderData<typeof segmentsLoader>();

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl">Segments</h1>
        <p className="text-sm text-muted-foreground">
          Dynamic segments are re-evaluated every 15 minutes (and on save). Static segments are lists you fill by CSV import.
        </p>
      </div>

      <div className="grid gap-5 lg:grid-cols-[1fr_380px]">
        <div className="overflow-x-auto rounded-lg border bg-white">
          <table className="data-table">
            <thead>
              <tr>
                <th>Segment</th>
                <th>Kind</th>
                <th>Members</th>
                <th>Evaluated</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {segments.length === 0 && (
                <tr>
                  <td colSpan={5} className="py-8 text-center text-muted-foreground">
                    No segments yet — create one on the right.
                  </td>
                </tr>
              )}
              {segments.map((s) => (
                <RowLink key={s.id} href={`/segments/${s.id}`}>
                  <td>
                    <Link to={`/segments/${s.id}`} className="ff-link font-medium">
                      {s.name}
                    </Link>
                    {s.system && <span className="ml-2 rounded bg-muted px-1.5 py-0.5 text-[10px] uppercase text-muted-foreground">default</span>}
                    {s.description && <div className="text-xs text-muted-foreground">{s.description}</div>}
                  </td>
                  <td>{s.kind}</td>
                  <td>
                    <Link to={`/contacts?segmentId=${s.id}`} className="ff-link">
                      {s.memberCount}
                    </Link>
                  </td>
                  <td className="whitespace-nowrap text-muted-foreground">{fmtAgo(s.lastEvaluatedAt)}</td>
                  <td>{s.kind === 'dynamic' && <EvaluateButton id={s.id} />}</td>
                </RowLink>
              ))}
            </tbody>
          </table>
        </div>
        <SegmentForm />
      </div>
    </div>
  );
}
